<template>
  <section class="user-info-wrap">
    <div class="container">
      <div class="custom-form order-detail">
        <a-form layout="horizontal" :form="form" @submit="handleSubmit">
          <div class="user-form">
            <div class="address-detail">
              <a-form-item
                label="Receiver's Name :"
                :validate-status="handleError('FullName') ? 'error' : ''"
                :help="handleError('FullName') || ''"
              >
                <a-input
                  v-decorator="[
                    'FullName',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input receivers full name!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Receiver's Full Name"
                ></a-input>
              </a-form-item>

              <a-form-item
                label="Receiver's Mobile Number :"
                :validate-status="handleError('MobileNumber') ? 'error' : ''"
                :help="handleError('MobileNumber') || ''"
              >
                <a-input
                  v-decorator="[
                    `ReceiversMobileNumber`,
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Phone Number!',
                        },
                      ],
                    },
                  ]"
                  placeholder="+977-**********"
                ></a-input>
              </a-form-item>

              <a-form-item label="Order For :">
                <a-radio-group
                  class="radio-container"
                  v-model="orderFor"
                  @change="onChangeOrderFor"
                >
                  <a-radio :value="0"> This is for Me </a-radio>
                  <a-radio :value="1"> This is a Gift </a-radio>
                </a-radio-group>
              </a-form-item>

              <a-form-item
                v-show="this.orderFor == 1"
                label="Sender's Name :"
                :validate-status="handleError('SFullName') ? 'error' : ''"
                :help="handleError('SFullName') || ''"
              >
                <a-input
                  placeholder="Sender's Full Name"
                  v-decorator="[
                    'SFullName',
                    {
                      rules: [
                        {
                          required: this.orderFor == 1 ? true : false,
                          message: 'Please enter your full name!',
                        },
                      ],
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item
                v-show="this.orderFor == 1"
                label="Sender's Email :"
                :validate-status="handleError('SEmail') ? 'error' : ''"
                :help="handleError('SEmail') || ''"
              >
                <a-input
                  placeholder="Sender's Email Address"
                  v-decorator="[
                    'SEmail',
                    {
                      rules: [
                        {
                          required: this.orderFor == 1 ? true : false,
                          message: 'Please enter your email!',
                        },
                      ],
                    },
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item
                label="Sender's Social Media :"
                v-show="this.orderFor == 1"
              >
                <a-radio-group
                  class="radio-container"
                  v-model="socialMedia"
                  @change="onChangeSM"
                >
                  <a-radio :value="1"> Viber </a-radio>
                  <a-radio :value="2"> Whatsapp </a-radio>
                  <!-- <a-radio :value="3"> Messenger </a-radio> -->
                </a-radio-group>
              </a-form-item>

              <a-form-item
                v-show="this.orderFor == 1"
                label="Sender's Social Media Username/Contact :"
                :validate-status="handleError('SMHandle') ? 'error' : ''"
                :help="handleError('SMHandle') || ''"
              >
                <a-input
                  v-decorator="['SMHandle']"
                  placeholder="Sender's Social Media Username/Contact"
                ></a-input>
              </a-form-item>

              <a-form-item
                v-show="this.orderFor == 1"
                label="Note :"
                :validate-status="handleError('Note') ? 'error' : ''"
                :help="handleError('Note') || ''"
              >
                <a-textarea
                  v-decorator="['Note']"
                  rows="3"
                  placeholder="Note"
                ></a-textarea>
              </a-form-item>

              <a-form-item
                label="Payment Mode :"
                :validate-status="handleError('PaymentMode') ? 'error' : ''"
                :help="handleError('PaymentMode') || ''"
              >
                <select
                  class="select"
                  v-model="selectedPaymentM"
                  @click="(e) => e.preventDefault()"
                >
                  <option
                    v-for="(item, index) in paymentOptions"
                    :value="item"
                    v-bind:key="index"
                  >
                    {{ item }}
                  </option>
                </select>
              </a-form-item>

              <a-form-item
                label="Delivery Area :"
                :validate-status="
                  handleError('DeliveryAdddress') ? 'error' : ''
                "
                :help="handleError('DeliveryAdddress') || ''"
              >
                <a-input
                  v-decorator="[
                    'DeliveryAdddress',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input your Delivery Address!',
                        },
                      ],
                    },
                  ]"
                  placeholder="Delivery Location"
                ></a-input>
                <div class="extra-charge">
                  Delivery Charges will be added based on your provided
                  location.
                  <br />We will call you back on provided number for order
                  confirmation.
                </div>
              </a-form-item>

              <!-- 
              <div class="promo-wrap">
                <a-form-item
                  label="Promo Code"
                  :validate-status="handleError('PromoCode') ? 'error' : ''"
                  :help="handleError('PromoCode') || ''"
                >
                  <a-input
                    v-decorator="[
                    'PromoCode'
              ]"
                    placeholder
                  ></a-input>
                </a-form-item>
                <div class="promo-send" @click="sendPromo">
                  <a-tooltip>
                    <template slot="title">Apply promo code to get discount.</template>
                    <a-button type="primary">Apply</a-button>
                  </a-tooltip>
                </div>
              </div> -->

              <div class="promo-info" v-if="this.promoInfo.status">
                {{ this.promoInfo.data }}
              </div>

              <br />

              <div class="head">Where should we deliver?</div>

              <CheckoutMap />

              <br />
              <br />
              <!-- <google-map /> -->
            </div>
          </div>

          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
              class="order-button"
              :disabled="hasErrors(form.getFieldsError())"
              >Submit Order</a-button
            >
          </a-form-item>
        </a-form>

        <!-- <router-link to="/confirmorder">
          <div class="custom-button">Confirm Order</div>
        </router-link> -->
      </div>
    </div>
  </section>
</template>

<script>
import ApiService from "../../services/api.service";
import { TokenService, LocationId } from "../../services/storage.service";
import GoogleMap from "../../components/GoogleMap.vue";
import { mapGetters, mapActions } from "vuex";
import UserService from "../../services/user.service";
import { GetPaymentModes } from "../../services/items.service";

import CheckoutMap from "./CheckoutMap";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

export default {
  name: "UserInfo",
  components: {
    GoogleMap,
    CheckoutMap,
    GetPaymentModes,
  },
  data() {
    return {
      hasErrors,
      promoInfo: {
        status: false,
        data: "",
      },
      form: this.$form.createForm(this),
      orderFor: 0,
      socialMedia: 0,
      socialM: "",
      paymentOptions: [],
      selectedPaymentM: "Cash",
    };
  },
  mounted() {
    this.getPaymentOptions();

    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
    this.form.setFieldsValue({
      FullName: this.loggedUser.hasOwnProperty("first_name")
        ? this.loggedUser.first_name
        : "",
      MobileNumber: this.loggedUser.hasOwnProperty("phone")
        ? this.loggedUser.phone
        : "",
      email: this.loggedUser.hasOwnProperty("email")
        ? this.loggedUser.email
        : "",
      DeliveryAdddress: this.loggedUser.hasOwnProperty("address")
        ? this.loggedUser.address
        : "",
      SFullName: "",
      SEmail: "",
      SSocialMedia: "",
      SMHandle: "",
      Note: "",
    });
  },
  watch: {
    getOrderError: function (val) {
      if ((val = "")) {
        return;
      } else {
        this.$notification.error({
          message: "Error",
          description: "Error while ordering food.",
        });
        setTimeout(this.clearOrderError, 3000);
      }
    },
  },
  computed: {
    ...mapGetters([
      "cartItems",
      "cartTotal",
      "loggedUser",
      "getOrderError",
      "locationMarker",
      "getMinOrder",
    ]),
  },
  methods: {
    ...mapActions(["addUserDetail", "clearOrderError", "addDiscount"]),

    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },

    // Only show error after a field is touched.
    passwordError() {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched("password") && getFieldError("password");
    },

    sendPromo() {
      let promo = this.form.getFieldsValue().PromoCode;
      UserService.promoSend(promo)
        .then((data) => {
          if (data.hasOwnProperty("code")) {
            (this.promoInfo.status = true),
              (this.promoInfo.data =
                "Congratulation! You get " +
                data.discount_percent +
                "% for this Order.");
            // this.addDiscount(data.discount_percent);
          } else {
            this.$notification.error({
              message: "Promo Code is not valid",
              description: "Please confirm your promo code as it is not valid.",
            });
          }
        })
        .catch((err) => console.log(err));
    },

    handleSubmit(e) {
      e.preventDefault();

      if (this.locationMarker === null) {
        this.$notification.error({
          message: "Please Pin Your Location",
          description: "Locate your address in map before ordering!",
        });
      } else {
        this.form.validateFields((err, values) => {
          // console.log("VALUES", values, this.socialMedia);
          if (!err && this.cartItems.length === 0) {
            // console.log(this.getMinOrder);
            this.$message.warning(
              "Cart Cannot be empty. \n Please select atleast one Item."
            );
          } else if (this.cartTotal < this.getMinOrder) {
            this.$message.warning(
              `"Cart should be atleast of NRs. ${this.getMinOrder} ."`
            );
          } else {
          }
        });
      }
    },

    onChangeSM(e) {
      if (e.target.value == 1) {
        this.socialM = "Viber";
      } else if (e.target.value == 2) {
        this.socialM = "Whatsapp";
      } else if (e.target.value == 3) {
        // this.socialM = "Messenger";
      }
    },

    onChangeOrderFor(e) {
      // console.log("radio checked", e.target.value);
    },

    getPaymentOptions: function () {
      GetPaymentModes.getItems(LocationId.getLocationId())
        .then((response) => {
          // console.log("Payment Options", response.user);
          this.paymentOptions = response.user;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.user-info-wrap {
  margin-top: 80px;
  background: #fbfbfb;
  .order-button {
    margin-top: 0;
  }
}

.custom-form {
  max-width: 500px;
  margin: 0 auto;
  text-align: center;
  .user-form {
    margin-bottom: 50px;
  }
}

.extra-charge {
  margin-top: 40px;
  color: $brand-color;
  font-weight: 600;
  font-family: $main-font;
  font-size: 12px;
  line-height: 24px;
}

.head {
  color: $text-color;
  font-weight: 600;
  padding-bottom: 12px;
  margin-bottom: 25px;
  font-size: 22px;
  position: relative;
  &::before,
  &::after {
    position: absolute;
    content: "";
    left: 50%;
    top: 100%;
    width: 31px;
    height: 2px;
    -ms-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    background-color: #91ad41;
  }
  &::after {
    width: 2px;
    margin-left: 20px;
    -ms-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
}
.radio-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin: 0px;
  label {
    padding: 0px 15px 0px 4px;
    color: $text-color2;
    font-weight: 500;
    font-family: $main-font;
    font-size: 13px;
    line-height: 24px;
  }
  // input[type="radio"] {
  //   background-color: lightgrey;
  //   border-radius: 10px;
  //   cursor: pointer;
  //   display: inline-block;
  //   height: 15px;
  //   position: relative;
  //   width: 15px;
  //   -webkit-appearance: none;
  // }
  // input[type="radio"]:after {
  //   background-color: #ffffff;
  //   border-radius: 25px;
  //   content: "";
  //   display: block;
  //   height: 7px;
  //   left: 4px;
  //   position: relative;
  //   top: 4px;
  //   width: 7px;
  // }
  // input[type="radio"]:checked:after {
  //   background-color: $brand-color;
  // }
}

.select {
  position: relative;
  font-family: $main-font;
  padding: 5px;
  height: 40px;
  border: 1px solid #d4d5d9;
  outline: none;
}

.select:hover {
  border: 1px solid $brand-color;
}

.select select {
  display: none; /*hide original SELECT element: */
}

.select-selected {
  background-color: $brand-color;
}

/* Style the arrow inside the select element: */
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}

/* Point the arrow upwards when the select box is open (active): */
.select-selected.select-arrow-active:after {
  border-color: transparent transparent #fff transparent;
  top: 7px;
}

/* style the items (options), including the selected item: */
.select-items div,
.select-selected {
  color: #ffffff;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
  cursor: pointer;
}

/* Style items (options): */
.select-items {
  position: absolute;
  background-color: $brand-color;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;
}

/* Hide the items when the select box is closed: */
.select-hide {
  display: none;
}

.select-items div:hover,
.same-as-selected {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>
